export const ROUTES = {
  BASE: '/direct-billing',
  BASE_NO_SLASH: 'direct-billing',
  START: 'start',
  ELIGIBLE_INSURERS: 'insurers',
  INSURANCE_MEMBER: 'insurance-member',
  INSURANCE_INFORMATION: 'insurance-information',
  QUOTE: 'quote',
  SELECT_PRESCRIPTION: 'select-prescription',
  VALIDATE_PRESCRIPTION: 'validate',
  SELECT_PRODUCT: 'select-product',
  REVIEW_CLAIM: 'review',
  SUBMIT_CLAIM: 'submit-claim',
  ACCEPTED: 'accepted',
  FIND_MEMBER: 'find-member',
  APPLY_INSURANCE: 'apply-insurance',
  DISTRIBUTE_BENEFITS: 'distribute-benefits',
  BENEFITS: 'benefits',
  ERROR: 'error',
  LOADING: 'loading',
  RESTRICTED: 'restricted',
}

export const ENDPOINTS = {
  DIRECT_BILLING: {
    BASE: '/services/direct-billing',
    AUTH_TOKEN: '/services/direct-billing/auth/token',
    CLAIMS: '/services/direct-billing/claims',
    CLAIM_RECORDS: '/services/direct-billing/claim-records',
    CUSTOMER: '/services/direct-billing/customer',
    INSURERS: '/services/direct-billing/insurers',
    INSURERS_PUBLIC: '/services/direct-billing/insurers/list',
    INSURER_DETAILS: '/services/direct-billing/insurers/{{insurerId}}',
    INSURANCE_PROVIDER: '/services/direct-billing/insurance-providers/{{insuranceProviderId}}',
    INSURANCE_PROVIDER_DEFAULT_FORMS:
      '/services/direct-billing/insurance-providers/{{insuranceProviderId}}/default-insurance-forms',
    DISPENSING_PRACTITIONERS: '/services/direct-billing/dispensing-practitioners',
    SERVICE_LOCATIONS: '/services/direct-billing/service-locations',
    CONFIGURATIONS: '/services/direct-billing/configurations',
    ATTACHMENTS: '/services/direct-billing/shared-services/attachments',
  },
}

export const TELUS = {
  // note: patient relationship is used in the insurer provider dynamic forms
  RELATIONSHIP: {
    SELF: 'SELF', // Insured member
    SPOUSE: 'SPOUSE',
    CHILD: 'CHILD',
    DEPENDENT: 'DEPENDENT',
    HANDICAPPED_DEPENDENT: 'HANDICAPPED_DEPENDENT',
    PART_TIME_STUDENT: 'PART_TIME_STUDENT',
    FULL_TIME_STUDENT: 'FULL_TIME_STUDENT',
    DOMESTIC_PARTNER: 'DOMESTIC_PARTNER',
  },

  GENDER: {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    OTHER: 'OTHER',
    UNKNOWN: 'UNKNOWN',
  },
  INCIDENT_TYPE: {
    MOTOR_VEHICLE: 'MOTOR_VEHICLE',
    SCHOOL: 'SCHOOL',
    SPORT: 'SPORT',
    WORKPLACE: 'WORKPLACE',
    OTHER: 'OTHER',
  },
  DOCTOR_CREDENTIAL: {
    OPTOMETRIST: 'OPTOMETRIST',
    OPHTHALMOLOGIST: 'OPHTHALMOLOGIST',
    MEDICAL_DOCTOR: 'MEDICAL_DOCTOR',
  },
}

export const DEFAULT_FIELD_MAX_LENGTH = 50
export const POLICY_NUMBER_FIELD_MAX_LENGTH = 12
export const MEMBER_ID_FIELD_MAX_LENGTH = 12

export const ALLOWED_FILETYPES = ['image/jpeg', 'image/png', 'application/pdf']

export const INSURANCE_COVERAGE_TYPE = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
}

export const MESSAGE_ANIMATION = {
  CARD_COUNT: 3,
  INTERVAL_MS: 7000,
}

export const PRESCRIPTION = {
  UPLOAD_POLLING_INTERVAL: 2000,
  UPLOAD_MAX_WAIT_TIME_MS: 2 * 60 * 1000,
  VALIDATION_POLLING_INTERVAL_MS: 2000,
  VALIDATION_MAX_WAIT_TIME_MS: 2 * 60 * 1000,
  VALIDATION_ANIMATION_INTERVAL_MS: 7000,
  MAX_FILE_SIZE_MB: 10,
}

export const CLAIM = {
  POLLING_INTERVAL_MS: 2000,
  NULLIFY_POLLING_INTERVAL_MS: 1000,
  MAX_WAIT_TIME_MS: 2 * 60 * 1000,
  MAX_TIMEOUT_RETRY: 3,
  MAX_NULLIFY_WAIT_TIME: 15 * 1000,
  MAX_AUTO_NULLIFY_WAIT_TIME: 2 * 60 * 1000,
  UPDATE_CART_POLLING_INTERVAL_MS: 1000,
}

export const QUOTE = {
  POLLING_INTERVAL_MS: 2000,
  MAX_WAIT_TIME_MS: 2 * 60 * 1000,
  MAX_WAIT_TIME_MS_REFUSE_QUOTE: 30 * 1000,
  MAX_TIMEOUT_RETRY: 3,
  CANCEL_QUOTE_RETRY_INTERVAL_MS: 500,
  CANCEL_QUOTE_MAX_RETRY: 3,
}

export const APPLY_INSURANCE = {
  MAX_ATTEMPTS: 5,
  POLLING_INTERVAL_MS: 2000,
  MAX_WAIT_TIME_MS: 2 * 60 * 1000,
  MAX_WAIT_TIME_TOGGLE_MS: 60 * 1000,
  MAX_WAIT_TIME_RESTRICTED_MS: 30 * 1000,
  MAX_TIMEOUT_RETRY: 3,
}

export const FORM_ACTION_INVOKE_THRESHOLD = 2 * 60 * 1000

export const PREFER_CACHE = true

export const EMPTY = {
  DASH: '—',
} as const
